import { t } from '@lingui/core/macro';
import { AgenticLoader } from '@pocketlaw/tetris';
import { useWorkflowCheck } from 'app/domains/workflows/features/WorkflowCheckProvider';
import { ReviewState } from './ReviewState';
import { WorkflowApproversProvider } from './WorkflowApproversProvider';
import { WorkflowInitialState } from './WorkflowInitialState';
export function RequestVoluntaryAdvanced(props) {
    const { workflows } = props;
    const { startCheck, state } = useWorkflowCheck();
    const handleSelectWorkflow = (workflowId) => {
        startCheck(workflowId);
    };
    const loading = state === 'evaluating';
    const loadingLabels = [
        t({ comment: 'Running approval rules check loading message', message: 'Checking rules...' }),
        t({ comment: 'Running approval rules check loading message', message: 'Evaluating rules...' }),
        t({ comment: 'Running approval rules check loading message', message: 'Applying rules...' }),
    ];
    return (<AgenticLoader loading={loading} loadingLabels={loadingLabels}>
      <WorkflowApproversProvider>
        {state === 'done' && <ReviewState />}

        {state === 'initial' && <WorkflowInitialState workflows={workflows} onSelectWorkflow={handleSelectWorkflow}/>}
      </WorkflowApproversProvider>
    </AgenticLoader>);
}
